/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Item_Disable_Posthog_DescInputs */

const en_dev_item_disable_posthog_desc = /** @type {(inputs: Dev_Item_Disable_Posthog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop PostHog from tracking events`)
};

const ar_dev_item_disable_posthog_desc = /** @type {(inputs: Dev_Item_Disable_Posthog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إيقاف تتبع الأحداث بواسطة PostHog`)
};

const bn_dev_item_disable_posthog_desc = /** @type {(inputs: Dev_Item_Disable_Posthog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PostHog-এর ইভেন্ট ট্র্যাকিং বন্ধ করুন`)
};

const de_dev_item_disable_posthog_desc = /** @type {(inputs: Dev_Item_Disable_Posthog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verhindern Sie, dass PostHog Ereignisse verfolgt`)
};

const es_dev_item_disable_posthog_desc = /** @type {(inputs: Dev_Item_Disable_Posthog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evitar que PostHog rastree eventos`)
};

const fr_dev_item_disable_posthog_desc = /** @type {(inputs: Dev_Item_Disable_Posthog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empêcher PostHog de suivre les événements`)
};

const pt_dev_item_disable_posthog_desc = /** @type {(inputs: Dev_Item_Disable_Posthog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impedir o PostHog de rastrear eventos`)
};

const zh_dev_item_disable_posthog_desc = /** @type {(inputs: Dev_Item_Disable_Posthog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阻止 PostHog 跟踪事件`)
};

const tr_dev_item_disable_posthog_desc = /** @type {(inputs: Dev_Item_Disable_Posthog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PostHog'un etkinlikleri izlemesini durdurun`)
};

const ru_dev_item_disable_posthog_desc = /** @type {(inputs: Dev_Item_Disable_Posthog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запретить PostHog отслеживать события`)
};

const pl_dev_item_disable_posthog_desc = /** @type {(inputs: Dev_Item_Disable_Posthog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatrzymaj PostHog przed śledzeniem zdarzeń`)
};

/**
* | output |
* | --- |
* | "Stop PostHog from tracking events" |
*
* @param {Dev_Item_Disable_Posthog_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dev_item_disable_posthog_desc = /** @type {((inputs?: Dev_Item_Disable_Posthog_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Item_Disable_Posthog_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dev_item_disable_posthog_desc(inputs)
	if (locale === "bn") return bn_dev_item_disable_posthog_desc(inputs)
	if (locale === "de") return de_dev_item_disable_posthog_desc(inputs)
	if (locale === "es") return es_dev_item_disable_posthog_desc(inputs)
	if (locale === "fr") return fr_dev_item_disable_posthog_desc(inputs)
	if (locale === "pt") return pt_dev_item_disable_posthog_desc(inputs)
	if (locale === "zh") return zh_dev_item_disable_posthog_desc(inputs)
	if (locale === "tr") return tr_dev_item_disable_posthog_desc(inputs)
	if (locale === "ru") return ru_dev_item_disable_posthog_desc(inputs)
	if (locale === "pl") return pl_dev_item_disable_posthog_desc(inputs)
	return en_dev_item_disable_posthog_desc(inputs)
});